"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationMessage = void 0;
exports.validationMessage = {
    roleNameRequiredFr: "Nom du rôle ne peut pas être vide",
    deedTypeRequiredEn: "Deed type is required",
    uidRequiredEn: "UID is required",
    officeRequiredEn: "Office is required",
    rulesRequiredEn: "Rules are required",
    labelRequiredEn: "Label is required",
    contactRequiredEn: "Contact is required",
    folderRequiredEn: "Folder is required",
    documentRequiredEn: "Document is required",
    nameRequiredEn: "Name is required",
};
